import { Injectable } from "@angular/core";
import {  
  Router,
} from "@angular/router";
import { HTTPService } from "./http.service";
import { Observable, map } from "rxjs";

@Injectable({
  providedIn: HTTPService,
  useValue: false,
})
export class IconServices {
  constructor(
    private http: HTTPService,
    public router: Router,    
  ) {}
  
  
  resultMktpTutorial = [];

  getIcons(id):Observable<Object[]>{

      let ob = {
          entityName:"Mktpicons",
      }
      return this.http.post(ob,'JsonBrokerServices/find',false,true,false).pipe(
          map(d=>{
                let icons = d['Mktpicons'] as Object[];
                let newArray = icons.map(a => {return {...{id:a["NAME"],name:a["NAME"]}}})
                return newArray;
          })
      )
    
  
      
  }


  async loadByPK(idTutorial) {
    await new Promise((resolve, reject) => {
      let sqlFindTutorial = ` SELECT IDTUTORIAL, NAME, TUTORIAL FROM MKTPTUTORIAL WHERE IDTUTORIAL = '${idTutorial}' AND ENABLE = 'S' `;

      let queryFindTutorial = {
        entityName: "MKTPTUTORIAL",
        sql: sqlFindTutorial,
      };

      this.http
        .post(
          queryFindTutorial,
          "JsonBrokerServices/findnative",
          false,
          true,
          true
        )
        .subscribe((con) => {
          let mktpTutorialSQL = con["SQL"];
          this.resultMktpTutorial = [];          

          mktpTutorialSQL.forEach((m) => {

            let optionsTutorial:JSON = JSON.parse(m["TUTORIAL"]);

            var stepTutorial = optionsTutorial["steps"];

            stepTutorial.forEach(element => {
              var nomeElement = element.nomeElement;
              var tipoFind = element.tipoFind; 
            

              if(tipoFind == "querySelector"){
                element.element = document.querySelector(nomeElement);
              }else if(tipoFind == "getElementsByClassName"){ //FIXME: No futuro entender como melhorar essa implementação.
                var childNumber = parseInt(element.childNumber); 
                var childNodeNumber = parseInt(element.childNodeNumber); 
                var elementFound = document.getElementsByClassName(nomeElement)[childNumber];

                if(elementFound != null){
                  element.element = elementFound.childNodes[childNodeNumber];
                }
                
              }

            });

            let mktpTutorial = {
              id: m["IDTUTORIAL"],
              name: m["NAME"],
              tutorial: optionsTutorial
            };

            this.resultMktpTutorial.push(mktpTutorial);            
          });

          resolve(this.resultMktpTutorial);
        });
    });
  }

  
}
